'use strict';

angular.module('rmOBA.03EmailPrint', ['ngRoute'])

    .config(['$routeProvider', function ($routeProvider) {
        $routeProvider.when('/03-email-and-print', {
            templateUrl: 'views/03EmailPrint/03EmailPrint.html'
        });
    }])

    /**
    * @memberof rmOBA
    * @ngdoc controller
    * @name 03EmailPrintControl
    * @param $scope {service} controller scope
    * @param $location {service} Angular location service
    * @param $modal {service} Angular Strap modal directive - Modals are streamlined, but flexible, dialog prompts with the minimum required functionality and smart defaults.
    * @param $filter {service} Angular filter directive - Selects a subset of items from array and returns it as a new array.
    * @param rmUtils {service} General utilites used in this app
    * @param rmOrdersUtils {service} Utility methods for Orders only
    * @param rmResources {service} Resources service - group and individual functions to gather form data from converted json files
    * @param rmUserLocationData {service} Gather user location data from local storage
    * @param rmUserPostalProductsData {service} Gather user created Order Lines data from local storage
    * @description 
    *   The final stage of the Emergency Order form. 
    *   Allows users to save CSV of orders or print a simplified version of their orders.
    */
    .controller('03EmailPrintCtrl', [
        '$scope',
        '$http',
        '$location',
        '$modal',
        '$filter',
        'rmUtils',
        'rmOrdersUtils',
        'rmResources',
        'rmUserLocationData',
        'rmUserPostalProductsData', function (
            $scope,
            $http,
            $location,
            $modal,
            $filter,
            rmUtils,
            rmOrdersUtils,
            rmResources,
            rmUserLocationData,
            rmUserPostalProductsData
        ) {

            var _this = this;
            $scope.orders = [];
            $scope.outputOrdering = {
                orderInCSV: {},
                orderInManifest: {},
                orderInForm: {},
                orderInSummary: {}
            };
            $scope.printOrderBtnDisabled = false;
            $scope.downloadCSVbtnDisabled = false;

            var storedUserLocationData = rmUserLocationData.get();
            var storedPostalProductData = rmUserPostalProductsData.get();

            // Pre-fetch an external template populated with a custom scope
            $scope.printManifestModal = $modal({ scope: $scope, templateUrl: 'views/print_manifest/print_manifest.modal.html', show: false, backdrop: 'static', });

            /**
            * @memberof 03EmailPrintControl
            * @function fileName
            * @desc Create a filename string prefixed with today's year, month and date.
            * @returns {string} The filename to save the CSV as
            */
            $scope.fileName = function () {
                var d = new Date();
                var filename = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + "_OBA_Emergency.csv";
                return filename;
            }

            rmResources.getOrderLinesData().then(function (data) {
                $scope.orderLinesData = data.data;
                // Create Ordering Models
                $scope.orderLinesData.forEach(function (orderLine) {
                    $scope.outputOrdering.orderInCSV[orderLine.Field] = orderLine['Order In CSV'];
                    $scope.outputOrdering.orderInManifest[orderLine.Field] = orderLine['Order In  Manifest'];
                    $scope.outputOrdering.orderInForm[orderLine.Field] = orderLine['Order In  Form'];
                    $scope.outputOrdering.orderInSummary[orderLine.Field] = orderLine['Order In  Summary'];
                });

                $scope.csvHeaders = rmOrdersUtils.getCSVHeaders($scope.orders);
                $scope.csvOrders = rmOrdersUtils.cleanOrders($scope.orders);
                $scope.csvOrders = rmOrdersUtils.addLocationData($scope.csvOrders, $scope.orderLinesData, $scope.locationData);
                $scope.sortOrderLines = rmOrdersUtils.sortOrderLines;
                $scope.orderHeadings = rmOrdersUtils.orderHeadings;
            });


            if (!_.isEmpty(storedPostalProductData)) {
                $scope.orders = storedPostalProductData;
            }

            if (!_.isEmpty(storedUserLocationData)) {
                $scope.locationData = storedUserLocationData;
            }


            /**
             * click download order button to enable print manifest
             */
            $scope.clickDownloadOrder = function () {
                $scope.printOrderBtnDisabled = true;
                $scope.downloadCSVbtnDisabled = true;
            }


            /**
            * @memberof 03EmailPrintControl
            * @function printManifest
            * @desc Redirect user to Print Manifest page 
            */
            $scope.printManifest = function (csvHeaders, csvOrders) {

                $scope.AccountNo = csvOrders[0]['Customer Account Number'];
                $scope.CustomerEmailID = csvOrders["0"]["OBA Customer Email Address"];

                var ocsvHeaders = rmOrdersUtils.orderHeadings(csvHeaders, $scope.outputOrdering.orderInCSV);
                var ocsvOrders = rmOrdersUtils.sortOrderLines(csvOrders, $scope.outputOrdering.orderInCSV);

                ocsvOrders = JSON.stringify(ocsvOrders);

                //Remove Product name from csvOrders array as its not required
                for (var i = 0; i < ocsvOrders.length; i++) {
                    delete ocsvOrders[i][ocsvOrders.length - 1];
                }

                var ocsvHeaders = JSON.stringify(ocsvHeaders);

                ocsvHeaders = ocsvHeaders.replace('[', '');
                ocsvHeaders = ocsvHeaders.replace(']', '');
                ocsvHeaders = ocsvHeaders + '\r\n';

                var strCsvO = $scope.JSONToCSVConvertor(ocsvOrders);

                var strCsvHO = ocsvHeaders + strCsvO;
                strCsvHO = strCsvHO.replace(/"/g, '');

                //Add the csv content returned to scope so that it can be passed to API call
                $scope.csvData = strCsvHO

                //Call sendgrid Email function
                $scope.sendGridEmail();

                //Show the PrintManifest Modal
                $scope.printManifestModal.$promise.then($scope.printManifestModal.show);

                //Disable the buttons so that only one option can be selected.
                $scope.printOrderBtnDisabled = true;
                $scope.downloadCSVbtnDisabled = true;
            }



            $scope.JSONToCSVConvertor = function (JSONData) {
                //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
                var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;

                var CSV = '';

                //1st loop is to extract each row
                for (var i = 0; i < arrData.length; i++) {
                    var row = "";

                    //2nd loop will extract each column and convert it in string comma-seprated
                    for (var index in arrData[i]) {
                        if (arrData[i][index] == null) {
                            row += ',';
                        }
                        else {
                            row += '' + arrData[i][index] + ',';
                        }
                    }

                    row.slice(0, row.length - 1);
                    row = row.replace(/,\s*$/, "");
                    //add a line break after each row
                    CSV += row + '\r\n';
                }

                if (CSV == '') {
                    console.log("Invalid data - Blank content");
                    return;
                }
                else {
                    return CSV;
                }

            }

            //Function to send automated Email using SendGrid API 
            $scope.sendGridEmail = function () {
                var sendGridEmailUrl = '/api/sendGrid';
                var sendPostData = { csvData: $scope.csvData, AccountNo: $scope.AccountNo, CustomerEmailID: $scope.CustomerEmailID }

                //Call to Api for send email
                $http.post(sendGridEmailUrl, sendPostData)
                    .then(function (response) {
                        if (response) {
                            console.log('Mail has been sent');
                            //$scope.message = 'mail send sucess!';
                        }
                    })
                    .catch(function (err, status) {
                        console.log('Mail failed' + err);
                        console.log(err);
                    });

            }

            rmUtils.tealiumTagOverlay({
                "pageName": "RM Web App >OBA >Alternative Order Form> 3. Email and Print",
                "pageMenuTree": "OBA|Alternative Order Form",
                "pageTemplate": "Form",
                "pageBreadCrumb": "Home|OBA|Alternative Order Form|3. Email and Print",
                "pageApplicationStep": "3. Email and Print"
            });

        }])

